var _desc, _use, _use2, _use3, _use4, _use5, _use6, _use7, _use8, _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSketch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2500,
    height: 575,
    viewBox: "0 0 200 46",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo-light") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created using Figma")), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "translate(63.385 5.816)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    fill: "#FDB300"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    transform: "translate(0 16.391)",
    fill: "#EA6C00"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    transform: "matrix(-1 0 0 1 50.71 16.391)",
    fill: "#EA6C00"
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    transform: "translate(10.04 16.391)",
    fill: "#FDAD00"
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f",
    transform: "translate(10.04)",
    fill: "#FDD231"
  })), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    transform: "matrix(-1 0 0 1 40.14 0)",
    fill: "#FDD231"
  })), _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h",
    transform: "matrix(-1 0 0 1 50.71 1.586)",
    fill: "#FDAD00"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1052 180)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i",
    transform: "translate(-1052 -178.414)",
    fill: "#FDAD00"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1052 180)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#j",
    transform: "translate(-1041.96 -180)",
    fill: "#FEEEB7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    fillRule: "evenodd",
    d: "M4.349 24.159l-.039-.513H0l.024.577c.265 6.42 4.625 10.674 12.378 10.674 7.395 0 12.424-3.815 12.424-9.59 0-3.122-1.091-5.332-3.17-6.84-1.6-1.161-3.511-1.816-6.682-2.498l-.697-.148-.691-.144C7.826 14.48 6 13.437 6 10.337c0-3.207 2.64-5.249 7.07-5.249 4.31 0 7.033 2.613 7.16 6.727l.017.537H24.526l-.013-.566c-.149-6.413-4.482-10.729-11.486-10.729-6.865 0-11.398 4.102-11.398 9.412 0 3.114 1.09 5.282 3.172 6.73 1.586 1.104 3.424 1.69 6.666 2.34a127.758 127.758 0 0 0 .994.196c3.067.602 4.42.974 5.655 1.687 1.533.885 2.293 2.149 2.293 4.107 0 3.4-2.878 5.337-7.918 5.337-4.824 0-7.818-2.402-8.142-6.707zM33.833.554V0H29.58v34.368h4.253V27.883l4.478-4.364 7.996 10.628.166.22h5.291l-.675-.889-9.765-12.873 9.006-8.97.95-.948H45.5l-.163.164-11.504 11.595V.554zm40.04 23.387h.525l.033-.522a28.418 28.418 0 0 0 .04-.846c.004-.144.006-.275.006-.391 0-6.988-4.645-12.136-11.509-12.136-6.851 0-11.732 5.48-11.732 12.403 0 7.124 4.66 12.448 11.777 12.448 5.381 0 9.539-3.182 11.037-8.008l.224-.721H69.814l-.132.37c-.94 2.642-3.487 4.395-6.625 4.395-4.1 0-6.96-2.807-7.475-6.992h18.292zm-18.412-3.32c.718-3.814 3.457-6.345 7.186-6.345 3.843 0 6.496 2.448 7.076 6.345H55.462zm32.724-6.212h.553V10.647h-5.183V4.23h-4.253v6.417h-4.297V14.409h4.297v13.254c0 4.348 2.258 6.705 6.402 6.705.723 0 1.347-.043 1.87-.116.324-.045.547-.092.67-.126l.406-.112v-3.939l-.672.145a11.382 11.382 0 0 1-.594.104 9.344 9.344 0 0 1-1.281.105c-1.816 0-2.548-.852-2.548-2.987V14.409h4.63zm13.192 20.488c5.841 0 9.965-3.745 11.001-9.044l.13-.665h-4.257l-.108.414c-.887 3.381-3.295 5.33-6.766 5.33-4.33 0-7.318-3.46-7.318-8.438 0-5.017 2.982-8.484 7.318-8.484 3.471 0 5.879 1.95 6.766 5.331l.108.414h4.257l-.13-.665c-1.036-5.3-5.16-9.044-11.001-9.044-6.785 0-11.582 5.519-11.582 12.448 0 6.89 4.804 12.403 11.582 12.403zM120.449.553V0h-4.244v34.368h4.244V20.465c0-4.066 2.468-6.452 6.212-6.452 3.576 0 5.372 2.077 5.372 6.009v14.346h4.244V19.4c0-5.555-3.429-9.246-9.085-9.246-2.91 0-5.249 1.07-6.743 2.604V.554z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b",
    fillRule: "evenodd",
    d: "M11.063 1.497L25.353 0l14.291 1.497 11.064 14.717-25.354 29.257L0 16.214 11.063 1.497z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    fillRule: "evenodd",
    d: "M10.27 0l15.084 29.08L0 0h10.27z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "d",
    fillRule: "evenodd",
    d: "M10.269 0l15.085 29.08L0 0h10.269z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    fillRule: "evenodd",
    d: "M0 0h30.108L15.054 29.08 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "f",
    fillRule: "evenodd",
    d: "M14.79 0L.778 1.513 0 16.391 14.79 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "g",
    fillRule: "evenodd",
    d: "M14.79 0L.778 1.513 0 16.391 14.79 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "h",
    fillRule: "evenodd",
    d: "M0 14.805L11.093 0l-.796 14.805H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "i",
    fillRule: "evenodd",
    d: "M0 14.805L11.092 0l-.796 14.805H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "j",
    fillRule: "evenodd",
    d: "M15.054 0L0 16.391h30.108L15.054 0z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSketch);
export default __webpack_public_path__ + "static/media/sketch.491ac138b707562664ce79d958564c08.svg";
export { ForwardRef as ReactComponent };